<h3 *ngIf="attributes?.sectionHeading">{{attributes?.sectionHeading}}</h3>
<h5 class="text-muted" *ngIf="attributes?.sectionSubHeading">{{attributes?.sectionSubHeading}}</h5>
<gallery id="imgGallery" (indexChange)="setCaption($event)" [autoPlay]="false"></gallery>

<div class="gallery-caption p-3 d-flex justify-content-center text-white" *ngIf="currentCaption?.caption">
    <div class="caption-text" [innerHTML]="currentCaption?.caption"></div>
</div>
